export const getDropdownMenuOverrides = theme => {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          marginTop: `${theme.spacing(0.5)}`,
          borderWidth: 0,
          height: "auto",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.secondary.dark
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${theme.palette.primary.light}`
          },
          "&.Mui-focused": {
            borderWidth: 0
          },
          fieldset: {
            border: `1px solid ${theme.palette.secondary.dark}`
          },
          "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderWidth: 0
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          "&.Mui-focused": {
            backgroundColor: `${theme.palette.info.main}66 !important`
          },
          "&[aria-selected='true']": {
            backgroundColor: `${theme.palette.info.main} !important`
          }
        },
        popupIndicator: {
          color: theme.palette.primary.dark
        },
        popupIndicatorOpen: {
          color: theme.palette.primary.main
        },
        paper: {
          border: `1px solid ${theme.palette.primary.light}`,
          boxShadow: "none",
          borderTopWidth: 0,
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          marginTop: -1,
          maxWidth: "none"
        },
        noOptions: {
          ...theme.typography.caption
        },
        popper: {
          "&::before": {
            content: "''",
            display: "block",
            height: 7,
            border: `1px solid ${theme.palette.primary.light}`,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            marginTop: -6
          }
        },
        listbox: {
          maxHeight: 150
        },
        tag: {
          borderRadius: 20,
          color: theme.palette.primary.main,
          border: `1px solid ${theme.palette.primary.light}`
        },
        root: {
          "&.skinny": {
            "& .MuiFormControl-root": {
              "& .MuiOutlinedInput-root": {
                paddingTop: 0.25,
                paddingBottom: 0.25,
                height: 42,
                "& .MuiOutlinedInput-input": {
                  marginLeft: 6,
                  "&:hover": {
                    cursor: "pointer"
                  }
                }
              }
            }
          }
        }
      }
    }
  };
};